export default __webpack_public_path__ + "static/thebottomline22-bc5c942e9be0491c0f521c54152b0efc.jpg";